<template>
  <div>
    <OrderBaseDetail
        :id="this.id"
        :orderNo="this.orderNo"
        :userNo="this.userNo"
        :department="this.department"
        :departmentName="this.departmentName"
        :age="this.age"
        :gender="this.gender"
        :status="this.status"
        :statusText="this.statusText"
        :score="this.score"
        :createTime="this.createTime"
    ></OrderBaseDetail>

<!--    量表列表-->
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <el-col>量表列表</el-col>
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>题目信息</th>
                  <th style="width: 200px">创建时间</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in this.scaleInfoList" :key="index" :class="{ 'emphasis' : shouldEmphasis(item)}">
                  <td>
                    <ScaleDetail :scaleData="JSON.parse(item.ScaleData)"></ScaleDetail>
                  </td>
                  <td>{{ item.CreateTime }}</td>
                </tr>
                </tbody>
              </table>
              <el-col style="margin-top: 50px;font-size: 20px">量表结论：</el-col>
              <div>{{ this.scaleSuggestion }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    wav table-->
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <el-col>音频列表</el-col>
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>状态</th>
                  <th>类型</th>
                  <th>分数</th>
                  <th>地址</th>
                  <th>创建时间</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in this.wavInfoList" :key="index">
                  <td>{{ item.StatusText }}</td>
                  <td>{{ item.WavTypeText }}</td>
                  <td>{{ item.Score }}</td>
                  <td>{{ item.WavPath }}</td>
                  <td>{{ item.CreateTime }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <el-col>检测成功的音频数量统计
                <router-link :to="{path:'/admin/eigen', query:{order_no:this.orderNo}}" target="_blank">点击查看特征图像</router-link>
              </el-col>
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>类型</th>
                  <th>正常语音数量</th>
                  <th>全部语音数量</th>
                  <th>正常比例</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>全部</td>
                  <td>{{ wavStat.Normal }}</td>
                  <td>{{ wavStat.Total }}</td>
                  <td>{{ wavStat.NormalRate }}</td>
                </tr>
                <tr>
                  <td>积极</td>
                  <td>{{ wavStat.PositiveNormal }}</td>
                  <td>{{ wavStat.PositiveTotal }}</td>
                  <td>{{ wavStat.PositiveNormalRate }}</td>
                </tr>
                <tr>
                  <td>中性</td>
                  <td>{{ wavStat.NeutralNormal }}</td>
                  <td>{{ wavStat.NeutralTotal }}</td>
                  <td>{{ wavStat.NeutralNormalRate }}</td>
                </tr>
                <tr>
                  <td>消极</td>
                  <td>{{ wavStat.NegativeNormal }}</td>
                  <td>{{ wavStat.NegativeTotal }}</td>
                  <td>{{ wavStat.NegativeNormalRate }}</td>
                </tr>
                <tr>
                  <td>故事</td>
                  <td>{{ wavStat.StoryNormal }}</td>
                  <td>{{ wavStat.StoryTotal }}</td>
                  <td>{{ wavStat.StoryNormalRate }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div>
              <div class="table-responsive" v-html="htmlContent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail } from '@/api/admin'
import OrderBaseDetail from '@/components/admin/drawer/OrderBaseDetail.vue'
import ScaleDetail from '@/components/admin/drawer/ScaleDetail.vue'

export default {
  name: 'OrderDetail',
  components: {
    OrderBaseDetail,
    ScaleDetail
  },
  props: {
    orderNo: String
  },
  data () {
    return {
      id: 0,
      userNo: '',
      department: '',
      departmentName: '',
      age: 0,
      gender: '',
      status: '',
      statusText: '',
      score: 0,
      createTime: '',
      wavInfoList: [],
      scaleInfoList: [],
      scaleSuggestion: '',
      wavStat: {},
      mddCount: -1
    }
  },
  computed: {
    htmlContent () {
      if (this.mddCount >= 4) {
        return '<div>&#128170;，细心呵护，专业支持</div>'
      } else if (this.mddCount === 3) {
        return '<div>&#128513;，需要关注，积极面对</div>'
      } else if (this.mddCount === 2) {
        return '<div>&#128513;&#128513;，温和波动，适时调整</div>'
      } else if (this.mddCount === 1) {
        return '<div>&#128513;&#128513;&#128513;，情绪稳定，适当关怀</div>'
      } else if (this.mddCount === 0) {
        return '<div>&#128513;&#128513;&#128513;&#128513;，情绪健康，状态佳</div>'
      } else {
        return ''
      }
    }
  },
  async created () {
    // 获取order详情
    const { Data: data } = await orderDetail(this.orderNo)
    if (data) {
      this.id = data.Id
      this.userNo = data.UserNo
      this.department = data.Department
      this.departmentName = data.DepartmentName
      this.age = data.Age
      this.gender = data.Gender
      this.status = data.Status
      this.statusText = data.StatusText
      this.score = data.Score
      this.createTime = data.CreateTime
      this.wavInfoList = data.WavInfoList
      this.scaleInfoList = data.ScaleInfoList
      this.scaleSuggestion = data.ScaleSuggestion
      this.wavStat = data.WavStat
      if (data.Status === 'ANALYZED_OK') {
        this.mddCount = data.WavStat.MddCount
      }
      // console.log(this.scaleSuggestion)
    }
  },
  methods: {
    shouldEmphasis (item) {
      // phq9 6,8,9
      if (item.ScaleData.indexOf('觉得自己很糟或觉得自己很失败，或让自己、家人失望') !== -1) {
        return true
      }
      if (item.ScaleData.indexOf('动作或说话速度缓慢到别人已经觉察？或正好相反—烦躁或坐立不安、动来动去的情况更胜于平常') !== -1) {
        return true
      }
      if (item.ScaleData.indexOf('有不如死掉或用某种方式伤害自己的念头') !== -1) {
        return true
      }
      // beck 7
      if (item.ScaleData.indexOf('你会有想要伤害自己的想法吗') !== -1) {
        return true
      }
      return false
    }
  }

}
</script>

<style scoped lang="less">
.emphasis {
  font-weight: bold;
  background-color: rgba(192,192,192,0.3);
}
</style>
